import {Component, OnInit} from '@angular/core';
import {SprintService} from '@components/sprint/sprint.service';
import {ProjectsService} from '@components/projects/projects.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BackendResponse} from '@app/interfaces/backendResponse';
import {ToastrService} from 'ngx-toastr';
import {HelperService} from '@app/services/helper/helper.service';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {BoardsService} from '@components/boards/boards.service';
import {Board} from '@components/boards/board-card/board-card.component';
import {ConstantsService} from '@app/services/constants/constants.service';
import {Task} from '@app/interfaces/task';
import {tap} from 'rxjs/operators';

interface List {
    id: string;
    head: string;
    items: any[];
    toggle: boolean;
    color: string;
    default_column: boolean;
    status: string;
}

@Component({
    selector: 'app-active-sprint',
    templateUrl: './active-sprint.component.html',
    styleUrls: ['./active-sprint.component.css']
})


export class ActiveSprintComponent implements OnInit {

    constructor(private sprintService: SprintService,
                private projectsService: ProjectsService,
                private router: Router,
                private toastr: ToastrService,
                private helperService: HelperService,
                private boardsService: BoardsService,
                private route: ActivatedRoute,
                private constantsSrv: ConstantsService) {
    }

    id: string;
    board: Board;
    title = 'Proventum Sprint';
    newColumnButton = false;
    newColumnName = '';
    list = [];
    loader = false;
    projectId: any = ''; // moze biti string ili number zbog projekata iz proventuma
    buttonDisabled = false;

    adminPermission = false;

    tasks = [];


    ngOnInit(): void {
        const admins: any[] = this.constantsSrv.getAdmins();
        const userId = +this.constantsSrv.creator_id;
        this.adminPermission = (admins.find(x => x === userId)) !== undefined;
        this.loader = true;
        this.route.data.subscribe(async (data) => {
            if (data) {
                this.projectId = data['data']._id;
                await this.getData();
            }

        });
    }

    getData() {
        this.tasks = [];
        return new Promise((resolve, reject) => {
            try {
                if (this.projectId) {
                    this.sprintService.getScrumBoard(this.projectId).subscribe((response: BackendResponse) => {
                        if (response.type === 'success') {
                            this.list = [];
                            let data: { board: object, sprints: [], tasks: [] } = response.data;
                            this.board = {
                                _id: data.board['_id'],
                                project_id: data.board['project_id'],
                                columns: data.board['columns'],
                                name: data.board['name'],
                                status: data.board['status'],
                                tasks: [],
                                projectData: data.board['project_id'] ? data.board['project_id'] : {},
                                createdAt: data.board['created_at'],
                                type: data.board['type'],
                            };
                            let columns: any[] = data.board['columns'];
                            if (columns) {
                                columns.sort((a, b) => {
                                    return a.orderNumber - b.orderNumber;
                                });
                                columns.forEach(subitem => {
                                    let listItem: List = {
                                        id: '',
                                        head: '',
                                        items: [],
                                        toggle: false,
                                        color: '',
                                        default_column: null,
                                        status: ''
                                    };
                                    listItem.head = subitem.title;
                                    listItem.id = subitem.id;
                                    listItem.items = subitem.tasks;
                                    listItem.color = subitem.color;
                                    listItem.toggle = false;
                                    listItem.default_column = subitem.default_column;
                                    listItem.status = subitem.status;
                                    let tasks: any[] = data.tasks;

                                    listItem.items = tasks.filter(x => {
                                            return x.column_id === subitem.id;
                                        }
                                    );
                                    this.tasks = this.tasks.concat(listItem.items);
                                    listItem.items.forEach(x => {
                                        let assigned = x['assigned'];
                                        let assignedArray = this.helperService.getUserDataForIds(assigned);
                                        x['assigned'] = assignedArray;
                                    });

                                    this.list.push(listItem);
                                });
                                this.loader = false;
                                resolve();
                            }


                        } else if (response.type === 'info') {
                            this.toastr.info('Nemate pokrenut sprint.');
                            this.router.navigate(['/backlog']);
                        } else {
                            // ukoliko nema sprint, prebaci korisnika u backlog da pokrene sprint
                            this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                        }


                    })
                } else {
                    this.router.navigate(['projects']);
                }
            } catch (e) {
                reject(e);
            }
        });


    }


    dropColumns(event: CdkDragDrop<string[]>) {
        if (event.previousIndex === event.currentIndex) return;
        moveItemInArray(this.list, event.previousIndex, event.currentIndex);
        this.changeOrderNumber();
    }

    drop(event: CdkDragDrop<string[]>) {
        let id = event.item.data._id;
        let sort = event.item.data.sort;
        const currentColumnId = event.container.id;
        let subtasksNotDone: any;


        if (event.previousContainer === event.container) {
            this.toastr.info('Zadatak mora biti premješten u kolonu različitu od trenutne.');
            return;
        }

        if (sort === 'task') {
            const isDefault = this.list.filter((item) => item.id === currentColumnId && item.default_column === true && item.status === 'ddone');
            this.tasks.filter(task => task._id === id).filter((item: Task) => {
                if (item.subtasks.length > 0) {
                    const filterSubtasks: any[] = item.subtasks.filter((x: Task) => x.status !== 'validated' && (x.status !== 'deleted' && x.status !== 'canceled'));
                    if (filterSubtasks.length > 0 && isDefault.length > 0) {
                        this.toastr.info('Podzadaci nisu završeni');
                        subtasksNotDone = true;
                        return;
                    } else {
                        subtasksNotDone = false;
                    }
                } else {
                    subtasksNotDone = false;
                }
            });
        }

        if ((sort === 'task' && (subtasksNotDone === false)) || sort === 'subtask') {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
            this.boardsService.transferTaskToColumn(id, event.container.id, this.board._id, sort).subscribe((responseData: BackendResponse) => {
                if (responseData.type == 'success') {
                    this.getData();
                } else {
                    this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.');
                }
            });
        }


    }


    changeOrderNumber() {
        let data: any[] = this.list.map((item, index) => {
            return {id: item.id, index: index};
        });
        this.boardsService.changeColumnOrderNumber(this.board._id, data).subscribe((responseData: BackendResponse) => {
            if (responseData.type === 'error') {
                this.toastr.error('Došlo je do greške. Molimo vas obratite se korisničkoj podršci.');
            }
        });

    }

    colorChange(event, column) {
        if (event === column.color) {
        }
        this.boardsService.colorChange(this.board._id, column.id, event).subscribe((responseData: BackendResponse) => {
            if (responseData.type !== 'success') {
                this.toastr.error('Došlo je do greške prilikom odabira boje. Molimo Vas obratite se korisničkoj podršci.');
            }
        });


    }

    get trackIds(): string[] {
        return this.list.map(items => items.id);
    }

    addColumn(boardId) {
        if (this.newColumnName == '' || !this.newColumnName) {
            this.toastr.info('Molimo Vas unesite pravilno ime kolone.');
            return;
        }

        this.boardsService.addNewColumnToBoard(boardId, this.newColumnName).subscribe(async (response: BackendResponse) => {
            if (response) {
                if (response.type == 'success') {
                    this.toastr.success(`Dodata je nova kolona ${this.newColumnName}`);
                    this.newColumnButton = false;
                    this.newColumnName = '';
                    await this.getData();
                } else if (response.type === 'info') {
                    this.toastr.info('Kolona sa unijetim imenom već postoji.');
                } else {
                    this.toastr.error('Došlo je do greške prilikom dodavanja nove kolone. Molimo Vas obratite se korisničkoj podršci.');
                }
            } else {
                this.toastr.error('Došlo je do greške prilikom dodavanja nove kolone. Molimo Vas obratite se korisničkoj podršci.');
            }
        });

    }

    completeSprints() {
        this.buttonDisabled = true;
        this.boardsService.completeSprints(this.board.project_id).subscribe((response: BackendResponse) => {
            if (response) {
                if (response.type === 'success') {
                    this.toastr.success('Uspješno ste zatvorili sprint.');

                } else {
                    this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                }
            }
            this.router.navigate(['/backlog']);
        });
    }

}
